import { Component, OnInit, Input, inject, DestroyRef } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { filter } from 'rxjs/operators';
import { CampaignService } from '../../services/campaign.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-campaign-long-pledge-settings',
  templateUrl: './campaign-long-pledge-settings.component.html',
  styleUrls: ['./campaign-long-pledge-settings.component.scss']
})
export class CampaignLongPledgeSettingsComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  @Input() formGroupCampaignTypeData: any = null;

  constructor(
    public campaignService: CampaignService
  ) { }

  ngOnInit(): void {
    const hideRecurring = this.formGroupCampaignTypeData.get('hideRecurring') as UntypedFormControl;
    const frequencyOptions = this.formGroupCampaignTypeData.get('frequencyOptions') as UntypedFormControl;
    
    hideRecurring.valueChanges.pipe(
      filter(value => value),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      frequencyOptions.clearValidators();
      frequencyOptions.setValue([]);
    });

    hideRecurring.valueChanges.pipe(
      filter(value => !value),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      frequencyOptions.setValidators([Validators.required]);
      if(frequencyOptions.value.length === 0) {
        frequencyOptions.setValue([0,1,2]);
      } else {
        frequencyOptions.setValue(frequencyOptions.value);
      }      
    });
  }
}
